module.exports = __webpack_public_path__ + "img/trash.32ce1c21.svg";